module.exports = __webpack_public_path__ + "img/application-icon.adc3ddb0.svg";